import { render, staticRenderFns } from "./ScreenAdv.vue?vue&type=template&id=6b7312f7&scoped=true&lang=pug"
import script from "./ScreenAdv.vue?vue&type=script&lang=ts"
export * from "./ScreenAdv.vue?vue&type=script&lang=ts"
import style0 from "./ScreenAdv.vue?vue&type=style&index=0&id=6b7312f7&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7312f7",
  null
  
)

export default component.exports